export default "__VITE_ASSET__Bh8K6e3O__"